module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "searchHelper followAccordionWidth hpadding",
    class: {
      open: _vm.mustBeShown
    }
  }, [_c('div', {
    staticClass: "accordionList viewOnly"
  }, [_c('transition-group', {
    attrs: {
      "name": "fade",
      "tag": "div",
      "css": false
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enter,
      "leave": _vm.leave
    }
  }, _vm._l((_vm.propositions), function(prop, index) {
    return _c('div', {
      key: 'p' + index,
      staticClass: "accordionList-item",
      class: {
        selected: _vm.selectedIndex == index
      },
      on: {
        "mousedown": function($event) {
          return _vm.selectProposition(prop)
        }
      }
    }, [_c('div', {
      staticClass: "header"
    }, [(prop.explanationKey) ? _c('span', [_vm._v(_vm._s(_vm.$t("searchHelper." + prop.explanationKey)))]) : _vm._e(), (prop.explanationKey) ? [_vm._v("  ")] : _vm._e(), _c('span', {
      class: {
        'text-light': prop.explanationKey
      }
    }, [_vm._v(_vm._s(prop.textToShow) + "  ")]), (prop.description) ? _c('span', {
      staticClass: "description"
    }, [_vm._v(_vm._s(prop.description))]) : _vm._e()], 2)])
  }), 0)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25b62630","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainWrapper/SearchHelper.vue
// module id = 1254
// module chunks = 1